<template>
    <div class="footer">
        <h5>핀모든</h5>
        <ul class="info">
            <li>대표이사 : 용현봉</li>
            <li>서울 강남구 테헤란로 313 (역삼동, 성지하이츠1) 11층 1118호</li>
            <li>사업자등록번호 : 794-81-02780</li>
            <li>불편사항 접수 : 02-501-0214</li>
            <li>help@finmodeun.com</li>
            <li><a href="#" title="금융상품판매대리중개업자등록증" @click="viewCert">대출성상품금융상품판매대리중개업 [등록증 확인하기]</a></li>
        </ul>
        <ul class="terms">
            <li><a href="#" title="" @click="termsDetail('1', '1')">서비스이용약관</a></li>
            <li><a href="#" title="" @click="termsDetail('1', '2')">개인정보처리방침</a></li>
            <li><a href="#" title="" @click="termsDetail('5', '5')">이용자고충처리방침</a></li>
        </ul>
        <div class="ctt term_detail">
        </div>
    </div>

    <ViewDialog ref="dialog" />
</template>

<script setup>
import {defineEmits, defineProps, onMounted, reactive, ref} from "vue";
import {$client} from "@/assets/js/utils";
import ViewDialog from "@/components/ViewDialog.vue";

const props = defineProps({
    call_page: String
});
const emits = defineEmits(['loadContents', 'back']);

let pageModel = reactive({});
const dialog = ref();

async function termsDetail(_termsTarget, _termsType) {
    let param = {
        terms_target: _termsTarget
        , terms_type: _termsType
        , call_page: props.call_page
    };

    emits('loadContents', '/common/TermDetail.vue', param);
}

onMounted(async () => {
    await init();
});

const init = async () => {
    let param = {
        terms_target: '5'
        , terms_type: '15'
        , call_page: props.call_page
    };

    await $client.post('/svc/terms/detail/by/termsType', param, function(response) {
        document.querySelector('.ctt.term_detail').innerHTML = response.terms_contents;
    });
}

const viewCert = async () => {
    dialog.value.openDialog("", "/img/finmodeun-cert.png");
}
</script>
